import { ChartConfig } from "../interface/chart.interfaces";

export const DEFAULT_CHART_CONFIG: ChartConfig = {
  height: 500,
  layout: {
    background: { type: "solid", color: "black" },
    textColor: "#afafaf",
  },
  grid: {
    vertLines: { color: "#101010" },
    horzLines: { color: "#101010" },
  },
  crosshair: {
    mode: 0,
  },
  rightPriceScale: {
    borderColor: "#101010",
    alignLabels: false,
  },
  timeScale: {
    borderColor: "#101010",
    timeVisible: true,
    secondsVisible: false,
  },
};

export const DEFAULT_CANDLE_SERIES_CONFIG = {
  upColor: "#22c55e", // Green for up candles
  downColor: "#ef4444", // Red for down candles
  borderUpColor: "#16a34a", // Darker green for borders
  borderDownColor: "#dc2626", // Darker red for borders
  wickUpColor: "#16a34a", // Darker green for wicks
  wickDownColor: "#dc2626", // Darker red for wicks
};

export const INDICATOR_COLORS = {
  plasma: "#6688aa66",
  // Darker, opaque colors to distinguish from price line
  support: "#2e7d32", // dark green
  resistance: "#c62828", // dark red
  breakoutLong: "#66bbff",
  breakoutShort: "#ff66bb",
};

export const LINE_STYLES = {
  plasma: {
    lineWidth: 1,
    lineStyle: 1,
  },
  support: {
    lineWidth: 2,
    lineStyle: 1,
  },
  resistance: {
    lineWidth: 1,
    lineStyle: 1,
  },
};
